import { memo } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as EyeIcon } from "../assets/Icons/view.svg";
import Translate from "../../../Components/MultiLanguage/Translate";

const PlutoViewAllCard = memo(({ link, isPortrait }) => {
  const cardClassName = `pluto-card view-all-card ${isPortrait ? 'portrait' : 'landscape'}`;
  
  return (
    <Link to={link} className="pluto-card-link view-all-link">
      <div className={cardClassName}>
        <div className="view-all-content">
          <div className="eye-icon">
            <EyeIcon />
          </div>
          <span className="view-all-text"><Translate textKey={"view_all"} /></span>
        </div>
      </div>
    </Link>
  );
});

PlutoViewAllCard.displayName = "PlutoViewAllCard";
export default PlutoViewAllCard;
